import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { AppConstant } from "const";
import { IconX } from "@tabler/icons-react";

const useHandleSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = snackbarId => (
    <button
      className="btn btn-icon btn-ghost-light btn-sm"
      onClick={() => closeSnackbar(snackbarId)}
      style={{ color: "#ddd" }}
    >
      <IconX size={16} />
    </button>
  );

  const handleOpenSnackbar = e => {
    const message = e?.detail?.message || null;
    const variant = e?.detail?.variant || "success";
    if (message) {
      enqueueSnackbar(message, { variant: variant, action: action });
    }
  };

  const handleOpenMultipleSnackbar = e => {
    const notifications = e?.detail || [];
    notifications.forEach(notification => {
      const message = notification.message || null;
      const variant = notification.variant || "success";
      if (message) enqueueSnackbar(message, { variant: variant, action: action });
    });
  };

  useEffect(() => {
    window.addEventListener(AppConstant.CUSTOM_EVENTS.openSnackbar, handleOpenSnackbar);
    window.addEventListener(AppConstant.CUSTOM_EVENTS.openMultipleSnackbar, handleOpenMultipleSnackbar);

    return () => {
      window.removeEventListener(AppConstant.CUSTOM_EVENTS.openSnackbar, handleOpenSnackbar);
      window.removeEventListener(AppConstant.CUSTOM_EVENTS.openMultipleSnackbar, handleOpenMultipleSnackbar);
    };
  });
};

export default useHandleSnackbar;
